<div class="editor-page">
  <div class="container-xxl editor">
    <header class="editor-head">
      <div class="editor-banner">
        <img src="assets/img/contactBar.png" alt="">
        <h1>Importazione da PDF</h1>
      </div>
      <p class="editor-lead">I dati comuni vengono applicati a ogni PDF della cartella scelta.</p>
      <p class="editor-note">I campi con <sup>*</sup> sono obbligatori.</p>
    </header>

    <form class="editor-form" [formGroup]="importForm">
      <section class="editor-panel">
        <h2>Classificazione</h2>
        <div class="field-grid field-grid-3">
          <div class="field-block">
            <label for="code">Codice articolo<sup>*</sup></label>
            <input id="code" class="field" type="text" placeholder="Codice univoco" formControlName="code">
            <p class="field-hint">Progressivo calcolato dal server.</p>
          </div>

          <div class="field-block">
            <label for="category">Categoria<sup>*</sup></label>
            <select id="category" class="field" formControlName="category">
              <option [ngValue]="null" disabled>Seleziona una categoria</option>
              @for (item of categoryOptions; track item.id) {
                <option [ngValue]="item">{{ item.title }}</option>
              }
            </select>
          </div>

          <div class="field-block">
            <label for="subCategory">Sottocategoria</label>
            <select id="subCategory" class="field" formControlName="subCategory">
              <option [ngValue]="null">Seleziona una sottocategoria</option>
              @for (option of subcategoryOptions; track option.id) {
                <option [ngValue]="option">{{ option.title }}</option>
              }
            </select>
          </div>
        </div>
      </section>

      <section class="editor-panel">
        <h2>Visibilità</h2>
        <div class="field-block visibility-block">
          <span class="field-label">Visibilità articolo</span>
          <div class="visibility-controls">
            <label class="switch" for="public">
              <input id="public" type="checkbox" role="switch" formControlName="public" (change)="enableDisablePublication()">
              <span class="switch-track" aria-hidden="true"></span>
              <span>Pubblico</span>
            </label>
            @if (importForm.get('public')?.value == 1) {
              <input id="public_year" class="field" type="text" inputmode="numeric" maxlength="4" placeholder="Anno"
                formControlName="public_year" aria-label="Anno pubblicazione"
                (input)="isCorrectPublicYear()"
                [class.is-invalid]="importForm.get('public_year')?.invalid && (importForm.get('public_year')?.dirty || importForm.get('public_year')?.touched)">
            }
          </div>
        </div>
      </section>

      <section class="editor-panel">
        <h2>Luogo di conservazione</h2>
        <div class="field-block">
          <label for="location">Luogo di conservazione<sup>*</sup></label>
          <input id="location" class="field" type="text" placeholder="Luogo" formControlName="location">
        </div>

        <div class="place-grid">
          <div class="field-block">
            <label for="floor">Piano<sup>*</sup></label>
            <input id="floor" class="field" type="text" placeholder="Piano edificio" formControlName="floor">
          </div>
          <div class="field-block">
            <label for="room">Stanza<sup>*</sup></label>
            <input id="room" class="field" type="text" formControlName="room">
          </div>
          <div class="field-block">
            <label for="rack">Scaffale<sup>*</sup></label>
            <input id="rack" class="field" type="text" formControlName="rack">
          </div>
          <div class="field-block">
            <label for="case">Contenitore<sup>*</sup></label>
            <input id="case" class="field" type="text" formControlName="case">
          </div>
        </div>
      </section>

      <section class="editor-panel">
        <h2>File</h2>
        <div class="field-block">
          <label for="folder">Cartella<sup>*</sup></label>
          <select id="folder" class="field" formControlName="folder">
            <option [ngValue]="null" disabled>Seleziona una cartella</option>
            @for (item of folders; track item) {
              <option [ngValue]="item">{{ item }}</option>
            }
          </select>
        </div>
        <aside class="file-note">
          <strong>Nome file</strong>
          <span>YYYY… — esempio: 1987 01 - LOMBARDI PINI LIDIA.pdf</span>
        </aside>
      </section>

      <div class="editor-actions">
        @if (!importForm.valid) {
          <p class="editor-hint">Compila correttamente tutti i campi per abilitare il caricamento.</p>
        }
        <button class="editor-save" type="button" [disabled]="!importForm.valid" (click)="insertArticles()">
          Salva
        </button>
      </div>
    </form>
  </div>
</div>
